import {
  Box,
  Button,
  Container,
  Grid,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import type { DialogProps } from '@mui/material';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import RestartAltIcon from '@material-ui/icons/RestartAlt';
import { casesApi } from 'src/api/casesApi';
import CreateCase from 'src/components/cases/CreateCase';
import SearchBar from 'src/components/widgets/searchBar/SearchBar';
import useSettings from 'src/hooks/useSettings';
import setTitle from 'src/utils/setTitle';
import useAuth from 'src/hooks/useAuth';
import CaseFilter from 'src/components/cases/CasesFilter';
import { Filter } from 'src/components/widgets/buttons/Filter';
import { ViewCaseStyle } from './styleSheet';
import { caseSortData, initialFilterState } from 'src/constants';
import { useLocation, useNavigate } from 'react-router';
import AllProjects from './allProjects';
import moment from 'moment';
import CasesTable from './CasesTable';
import ColumnConfig from 'src/components/ColumnConfig';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import BulkCreateDialog from './components/BulkCreateDialog';

const useStyles = ViewCaseStyle;

function ViewCases(props: any) {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  setTitle('CRM | Cases');
  const { user } = useAuth();
  const { hiddenColumns } = props;
  const { settings } = useSettings();
  type CaseViewStates = {
    id: string;
    name: string;
  };
  interface ApprovalStatus {
    value: string;
    label: string;
  }
  const [showAdvancedSearch, setShowAdvancedSearch] = useState<boolean>(false);
  const [autoRefresh, setAutoRefresh] = useState<number>(0);
  const [drawer, setDrawer] = useState<boolean>(false);
  const [bulkIds, setBulkIds] = useState<String>('');
  const [allData, setAllData] = useState<any>([]);
  const [isSubmit, setIsSubmit] = React.useState<boolean>(false);

  const initialFilters = initialFilterState;

  const [filtersApplied, setFiltersApplied] = useState(
    JSON.parse(localStorage.getItem('casesPagePg'))?.filtersApplied ||
      initialFilters
  );
  const [page, setPage] = useState<number>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesPageNo || 0
  );
  const [pageSize, setPageSize] = useState<number>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesPageLimit || 25
  );
  const handlePage = (temp: number) => {
    setPage(temp);
  };
  const [totalCount, setTotalCount] = useState<number>(0);
  const handlePageSize = (temp: number) => {
    setPageSize(temp);
  };
  const [search, setSearch] = useState<string>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesSearch || ''
  );

  const [sortData, setSortData] = useState<any>({
    ...caseSortData,
  });
  const toggleSortData = (fieldName: string) => {
    type SortStatusType = 'asc' | 'desc';
    let sortStatus: SortStatusType = 'asc';
    const initial: SortDataTypes = {
      id: 'asc',
      caseName: 'asc',
      organization: 'asc',
      createdBy: 'asc',
      createdAt: 'asc',
      assignee: 'asc',
      caseType: 'asc',
      project: 'asc',
      resolveTime: 'asc',
      firstResponseTime: 'asc',
      priority: 'asc',
      status: 'asc',
      totalLoggedTime: 'asc',
      isApproved: 'asc',
      dueDate: 'asc',
      collaborators: 'asc',
      reOpened: 'asc',
      approvedDate: 'asc',
      module: 'asc',
    };

    // eslint-disable-next-line default-case
    switch (fieldName) {
      case 'id':
        if (sortData.id === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          id: sortStatus,
        });
        break;
      case 'title':
        if (sortData.caseName === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          caseName: sortStatus,
        });
        break;
      case 'organization':
        if (sortData.organization === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          organization: sortStatus,
        });
        break;
      case 'reporter':
        if (sortData.createdBy === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          createdBy: sortStatus,
        });
        break;
      case 'createdAt':
        if (sortData.createdAt === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          createdAt: sortStatus,
        });
        break;
      case 'assignee':
        if (sortData.assignee === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          assignee: sortStatus,
        });
        break;
      case 'type':
        if (sortData.caseType === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          caseType: sortStatus,
        });
        break;
      case 'project':
        if (sortData.project === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          project: sortStatus,
        });
        break;
      case 'resolveTime':
        if (sortData.resolveTime === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          resolveTime: sortStatus,
        });
        break;
      case 'firstResponseTime':
        if (sortData.firstResponseTime === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          firstResponseTime: sortStatus,
        });
        break;
      case 'priority':
        if (sortData.priority === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          priority: sortStatus,
        });
        break;
      case 'status':
        if (sortData.status === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          status: sortStatus,
        });
        break;
      case 'totalLoggedTime':
        if (sortData.totalLoggedTime === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          totalLoggedTime: sortStatus,
        });
        break;
      case 'isApproved':
        if (sortData.isApproved === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          isApproved: sortStatus,
        });
        break;
      case 'dueDate':
        if (sortData.dueDate === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          dueDate: sortStatus,
        });
        break;
      case 'collaborators':
        if (sortData.collaborators === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          collaborators: sortStatus,
        });
        break;
      case 'reOpened':
        if (sortData.reOpened === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          reOpened: sortStatus,
        });
        break;
      case 'approvedDate':
        if (sortData.approvedDate === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          approvedDate: sortStatus,
        });
        break;
      case 'module':
        if (sortData.module === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...initial,
          module: sortStatus,
        });
        break;
    }
  };

  const [columns, setColumns] = useState(() => {
    const savedOrder = localStorage.getItem('casesTableColumnOrder');
    const savedVisibility = localStorage.getItem('casesTableColumns');

    // Define default visible columns in the desired order
    const defaultVisibleColumns = [
      'attachment',
      'caseKey',
      'summary', // equivalent to 'title'
      'priority',
      'status',
      'project',
      'createdBy', // equivalent to 'reporter'
      'assignee',
      'totalLoggedTime',
      'createdAt',
    ];

    // Start with the base column configuration
    let initialColumns = [
      {
        id: 'attachment',
        label: 'Attachment',
        isSort: false,
        toggleSortData,
        direction: sortData.attachment,
      },
      {
        id: 'caseKey',
        label: 'Case #',
        isSort: true,
        toggleSortData,
        direction: sortData.caseKey,
      },
      {
        id: 'summary',
        label: 'Title',
        isSort: true,
        toggleSortData,
        direction: sortData.summary,
      },
      {
        id: 'caseType',
        label: 'Case Type',
        isSort: true,
        toggleSortData,
        direction: sortData.caseType,
      },
      {
        id: 'createdBy',
        label: 'Created By',
        isSort: true,
        toggleSortData,
        direction: sortData.createdBy,
      },
      {
        id: 'isEscalated',
        label: 'Escalated',
        isSort: true,
        toggleSortData,
        direction: sortData.isEscalated,
      },
      {
        id: 'escalationManager',
        label: 'Escalation Manager',
        isSort: true,
        toggleSortData,
        direction: sortData.escalationManager,
      },
      {
        id: 'issueType',
        label: 'Issue Type',
        isSort: true,
        toggleSortData,
        direction: sortData.issueType,
      },
      {
        id: 'organization',
        label: 'Organization',
        isSort: true,
        toggleSortData,
        direction: sortData.organization,
      },
      {
        id: 'priority',
        label: 'Priority',
        isSort: true,
        toggleSortData,
        direction: sortData.priority,
      },
      {
        id: 'project',
        label: 'Project',
        isSort: true,
        toggleSortData,
        direction: sortData.project,
      },
      {
        id: 'projectSponsor',
        label: 'Sponsor',
        isSort: true,
        toggleSortData,
        direction: sortData.projectSponsor,
      },
      {
        id: 'stakeHolder',
        label: 'Stakeholder',
        isSort: true,
        toggleSortData,
        direction: sortData.stakeHolder,
      },
      {
        id: 'status',
        label: 'Status',
        isSort: true,
        toggleSortData,
        direction: sortData.status,
      },
      {
        id: 'updatedAt',
        label: 'Updated At',
        isSort: true,
        toggleSortData,
        direction: sortData.updatedAt,
      },
      {
        id: 'updatedBy',
        label: 'Updated By',
        isSort: true,
        toggleSortData,
        direction: sortData.updatedBy,
      },
      {
        id: 'severity',
        label: 'Severity',
        isSort: true,
        toggleSortData,
        direction: sortData.severity,
      },
      {
        id: 'bugQuestions',
        label: 'Bug Questions',
        isSort: true,
        toggleSortData,
        direction: sortData.bugQuestions,
      },
      {
        id: 'expense',
        label: 'Expense',
        isSort: true,
        toggleSortData,
        direction: sortData.expense,
      },
      {
        id: 'billingAccountType',
        label: 'Account',
        isSort: true,
        toggleSortData,
        direction: sortData.billingAccountType,
      },
      {
        id: 'approvedBy',
        label: 'Approved By',
        isSort: true,
        toggleSortData,
        direction: sortData.approvedBy,
      },
      {
        id: 'docUrls.figmaLinks',
        label: 'Figma Links',
        isSort: true,
        toggleSortData,
        direction: sortData.figmaLinks,
      },
      {
        id: 'docUrls.googleDocLinks',
        label: 'Google Links',
        isSort: true,
        toggleSortData,
        direction: sortData.googleDocLinks,
      },
      {
        id: 'sprint',
        label: 'Sprint',
        isSort: true,
        toggleSortData,
        direction: sortData.sprint,
      },
      {
        id: 'releaseVersion',
        label: 'Release Version',
        isSort: true,
        toggleSortData,
        direction: sortData.releaseVersion,
      },
      {
        id: 'assignee',
        label: 'Assignee',
        isSort: true,
        toggleSortData,
        direction: sortData.assignee,
      },
      {
        id: 'totalLoggedTime',
        label: 'Time (Logged/Est)',
        isSort: true,
        toggleSortData,
        direction: sortData.totalLoggedTime,
      },
      {
        id: 'createdAt',
        label: 'Created At',
        isSort: true,
        toggleSortData,
        direction: sortData.createdAt,
      },
      {
        id: 'isApproved',
        label: 'Approved',
        isSort: true,
        toggleSortData,
        direction: sortData.isApproved,
      },
      {
        id: 'dueDate',
        label: 'Due Date',
        isSort: true,
        toggleSortData,
        direction: sortData.dueDate,
      },
      {
        id: 'collaborators',
        label: 'Collaborators',
        isSort: true,
        toggleSortData,
        direction: sortData.collaborators,
      },
      {
        id: 'reOpened',
        label: 'Reopened',
        isSort: true,
        toggleSortData,
        direction: sortData.reOpened,
      },
      {
        id: 'approvedDate',
        label: 'Approved Date',
        isSort: true,
        toggleSortData,
        direction: sortData.approvedDate,
      },
      {
        id: 'module',
        label: 'Module',
        isSort: true,
        toggleSortData,
        direction: sortData.module,
      },
    ];

    // Apply saved visibility settings if they exist
    if (savedVisibility) {
      const visibilitySettings = JSON.parse(savedVisibility);
      initialColumns = initialColumns.map((col) => ({
        ...col,
        isVisible: visibilitySettings[col.id] !== false,
      }));
    } else {
      // If no saved settings, apply default visibility
      initialColumns = initialColumns.map((col) => ({
        ...col,
        isVisible: defaultVisibleColumns.includes(col.id),
      }));
    }

    // Apply saved order if it exists, otherwise use default order
    if (savedOrder) {
      const orderIds = JSON.parse(savedOrder);
      const orderedColumns = [];

      // First add columns in the saved order
      orderIds.forEach((id) => {
        const column = initialColumns.find((col) => col.id === id);
        if (column) orderedColumns.push(column);
      });

      // Then add any new columns that weren't in the saved order
      initialColumns.forEach((col) => {
        if (!orderIds.includes(col.id)) {
          orderedColumns.push(col);
        }
      });

      return orderedColumns;
    }

    return initialColumns;
  });

  const handleColumnToggle = (columnId: string) => {
    const newColumns = columns.map((col) =>
      col.id === columnId ? { ...col, isVisible: !col.isVisible } : col
    );
    setColumns(newColumns);

    // Save visibility settings
    const visibilitySettings = newColumns.reduce(
      (acc, col) => ({
        ...acc,
        [col.id]: col.isVisible,
      }),
      {}
    );
    localStorage.setItem(
      'casesTableColumns',
      JSON.stringify(visibilitySettings)
    );
  };

  const handleColumnReorder = (
    sourceIndex: number,
    destinationIndex: number
  ) => {
    const newColumns = Array.from(columns);
    const [removed] = newColumns.splice(sourceIndex, 1);
    newColumns.splice(destinationIndex, 0, removed);
    setColumns(newColumns);

    // Save order
    const orderIds = newColumns.map((col) => col.id);
    localStorage.setItem('casesTableColumnOrder', JSON.stringify(orderIds));
  };

  const handleCloseDrawer = () => {
    setDrawer(!drawer);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const addCases = useCallback(
    async (open: boolean, event: any) => {
      if (
        event?.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }
      setDrawer(open);
    },
    [drawer]
  );

  const handleAddBulkIds = (id: String) => {
    setBulkIds(id);
  };

  const handleRemoveBulkIds = (id: String) => {
    setBulkIds(id);
  };

  const toggleAdvancedSearch = () => {
    setShowAdvancedSearch(!showAdvancedSearch);
  };

  type SortDataTypes = {
    id: 'asc' | 'desc';
    caseName: 'asc' | 'desc';
    organization: 'asc' | 'desc';
    createdBy: 'asc' | 'desc';
    createdAt: 'asc' | 'desc';
    assignee: 'asc' | 'desc';
    caseType: 'asc' | 'desc';
    project: 'asc' | 'desc';
    resolveTime: 'asc' | 'desc';
    firstResponseTime: 'asc' | 'desc';
    priority: 'asc' | 'desc';
    status: 'asc' | 'desc';
    totalLoggedTime: 'asc' | 'desc';
    isApproved: 'asc' | 'desc';
    dueDate: 'asc' | 'desc';
    collaborators: 'asc' | 'desc';
    reOpened: 'asc' | 'desc';
    approvedDate: 'asc' | 'desc';
    module: 'asc' | 'desc';
  };
  type SortOption = {
    key: string;
    value: string;
  };

  const [selectedSort, setSelectedSort] = useState<SortOption>({
    key:
      JSON.parse(localStorage.getItem('casesPagePg'))?.casesSelectedSortKey ||
      '',
    value:
      JSON.parse(localStorage.getItem('casesPagePg'))?.casesSelectedSortValue ||
      '',
  });

  const fieldToColumnMap = {
    id: 'caseKeyTruncate',
    title: 'summary',
    organization: 'organization.name',
    reporter: 'createdBy.name',
    assignee: 'assignee.name',
    type: 'caseType.name',
    resolveTime: 'sla.actualTime.resolveTime',
    firstResponseTime: 'sla.actualTime.firstResponseTime',
    priority: 'priority.rank',
    status: 'status.rank',
    project: 'project.name',
    createdAt: 'createdAt',
    totalLoggedTime: 'totalLoggedTime',
    caseKey: 'caseKey',
    isApproved: 'isApproved',
    dueDate: 'dueDate',
    collaborators: 'collaborators.name',
    reOpened: 'reOpened',
    approvedDate: 'approvedDate',
    module: 'module',
  };

  /** advance filters */
  type DateRange = {
    to: Date | null;
    from: Date | null;
  };
  const [date, setDate] = React.useState<DateRange>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesDate || {
      to: null,
      from: null,
    }
  );
  const [caseType, setCaseType] = React.useState<CaseViewStates[]>(
    (JSON.parse(localStorage.getItem('casesPagePg'))?.casesCaseType ||
      []) as CaseViewStates[]
  );
  const [project, setProject] = React.useState<any>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesProject || []
  );
  const [organization, setOrganization] = React.useState<CaseViewStates[]>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesOrganization || []
  );
  const [priority, setPriority] = React.useState<CaseViewStates[]>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesPriority || []
  );
  const [stakeholder, setStakeholder] = React.useState<CaseViewStates[]>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesStakeholder || []
  );
  const [assignee, setAssignee] = React.useState<CaseViewStates[]>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesAssignee || []
  );
  const [projectSponser, setProjectSponser] = React.useState<CaseViewStates[]>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesProjectSponser || []
  );
  const [escalationManager, setEscalationManager] = React.useState<
    CaseViewStates[]
  >(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesEscalationManager ||
      []
  );
  const [status, setStatus] = React.useState<CaseViewStates[]>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesStatus || []
  );
  const [excludeStatus, setExcludeStatus] = React.useState<CaseViewStates[]>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesExcludeStatus || []
  );
  const [hasAttachments, setHasAttachments] = React.useState<boolean>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesHasAttachments ||
      false
  );
  const [isEscalated, setIsEscalated] = React.useState<boolean>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesIsEscalated || false
  );
  const [isFirstResponseTimeViolated, setIsFirstResponseTimeViolated] =
    React.useState<boolean>(
      JSON.parse(localStorage.getItem('casesPagePg'))
        ?.casesIsFirstResponseTimeViolated || false
    );
  const [isSynced, setIsSynced] = React.useState<boolean>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesIsSynced || false
  );
  const [isResolveTimeViolated, setIsResolveTimeViolated] =
    React.useState<boolean>(
      JSON.parse(localStorage.getItem('casesPagePg'))
        ?.casesIsResolvedTimeViolated || false
    );

  const [newTicketIds, setNewTicketIds] = useState<CaseViewStates[]>([]);
  const [module, setModule] = React.useState<string | null>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesModule || null
  );

  const [isApproved, setIsApproved] = React.useState<any>(
    JSON.parse(localStorage.getItem('casesPagePg'))?.casesIsApproved || null
  );

  const getAllData = async (searchVal: any = null) => {
    try {
      const columnValue = fieldToColumnMap[selectedSort?.key] || 'defaultSort';
      const payload = {
        page,
        pageSize,
        search: searchVal !== null ? searchVal : search,
        caseType: caseType?.map((itm) => itm.id).toString(),
        priority: priority?.map((itm) => itm.id).toString(),
        stakeholder: stakeholder?.map((itm) => itm.id).toString(),
        assignee: assignee?.map((itm) => itm.id).toString(),
        projectSponser: projectSponser?.map((itm) => itm.id).toString(),
        escalationManager: escalationManager?.map((itm) => itm.id).toString(),
        status: status?.map((itm) => itm.id).toString(),
        statusNotInclude: excludeStatus?.map((itm) => itm.id).toString(),
        projectId: project?.map((itm) => itm.id).toString(),
        organizationId: organization?.map((itm) => itm.id).toString(),
        hasAttachments,
        isEscalated,
        isFirstResponseTimeViolated,
        isSynced,
        isResolveTimeViolated,
        from: date?.from,
        to: date?.to,
        column: columnValue,
        sort: selectedSort?.value === 'asc' ? '1' : '-1',
        module: module || '',
        ...(isApproved && isApproved !== 'null'
          ? { isApproved: isApproved !== 'false' }
          : {}),
      };
      if (selectedSort?.key === '' || selectedSort?.value === undefined) {
        delete payload.column;
        delete payload.sort;
      }
      const keys = Object.keys(payload);
      const values = Object.values(payload);

      // Create an array to store the non-empty key-value pairs
      const queryParams = [];
      for (let i = 0; i < values.length; i++) {
        if (values[i] !== '' && values[i] !== null && values[i] !== undefined) {
          queryParams.push(`${encodeURIComponent(keys[i])}=${values[i]}`);
        }
      }
      const queryString = queryParams.join('&');
      let response = await casesApi.advanceSearch(queryString);
      response = response?.data;
      const existingTicketIds = allData?.map((ticket) => ticket.id);
      // Compare with existing data to find newly added tickets
      const newTickets = response?.data?.filter(
        (ticket) => !existingTicketIds.includes(ticket.id)
      );

      if (newTickets.length > 0 && autoRefresh !== 0) {
        setNewTicketIds(newTickets.map((ticket) => ticket.id));
      }
      setAllData(response?.data);
      setTotalCount(response?.totalRecords);
      setIsSubmit(false);
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
        setAllData([]);
        setTotalCount(0);
      }
    }
  };

  const handleSearch = (val) => {
    setSearch(val);
    if (val === '') {
      setFiltersApplied({
        ...filtersApplied,
        search: null,
      });
    } else {
      setFiltersApplied({
        ...filtersApplied,
        search: {
          name: 'Search',
          data: val,
        },
      });
    }
    getAllData(val);
  };

  const deleteCaseById = async (id: String) => {
    try {
      const res = await casesApi.deleteCase(id);
      if (res?.status === 200) {
        toast.success('Case deleted successfully');
        getAllData();
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleAutoRefresh = (event) => {
    const newDuration = parseInt(event.target.value, 10);
    setAutoRefresh(newDuration);
  };

  const requiredPermissions = [
    'case-get-all',
    'case-filter-tabs-read',
    'case-filter-advanced-search-read',
    'case-filter-autorefresh-read',
    'case-create',
    'case-toggle-status',
    'case-delete',
    'case-bulk-deactivate',
    'case-get-by-id',
    'case-update',
  ];
  const permissions = {
    getAll: user?.permissions?.includes('case-get-all'),
    filterTabs: user?.permissions?.includes('case-filter-tabs-read'),
    create: user?.permissions?.includes('case-create'),
    toggleStatus: user?.permissions?.includes('case-toggle-status'),
    delete: user?.permissions?.includes('case-delete'),
    bulkDeactivate: user?.permissions?.includes('case-bulk-deactivate'),
    getById: user?.permissions?.includes('case-get-by-id'),
    update: user?.permissions?.includes('case-update'),
  };
  const updateAutocompleteState = (id, newData): any => {
    switch (id) {
      case 'caseType':
        setCaseType(newData);
        break;
      case 'priority':
        setPriority(newData);
        break;
      case 'stakeholder':
        setStakeholder(newData);
        break;
      case 'assignee':
        setAssignee(newData);
        break;
      case 'projectSponser':
        setProjectSponser(newData);
        break;
      case 'escalationManager':
        setEscalationManager(newData);
        break;
      case 'status':
        setStatus(newData);
        break;
      case 'excludeStatus':
        setExcludeStatus(newData);
        break;
      case 'hasAttachments':
        setHasAttachments(newData);
        break;
      case 'escalatedCases':
        setIsEscalated(newData);
        break;
      case 'isFirstResponseTimeViolated':
        setIsFirstResponseTimeViolated(newData);
        break;
      case 'isSynced':
        setIsSynced(newData);
        break;
      case 'isResolveTimeViolated':
        setIsResolveTimeViolated(newData);
        break;
      case 'date':
        setDate(newData);
        break;
      case 'project':
        setProject(newData);
        break;
      case 'organization':
        setOrganization(newData);
        break;
      case 'module':
        setModule(newData);
        break;
      case 'isApproved':
        setIsApproved(newData);
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    if (
      !requiredPermissions?.some((permission) =>
        user?.permissions?.includes(permission)
      )
    ) {
      window.location.href = '/admin/not-found';
    }
    getAllData();
    const casesPagePg = {
      casesPageLimit: pageSize,
      casesPageNo: page,
      casesSearch: search,
      casesSortId: sortData?.id,
      casesSortCaseName: sortData?.caseName,
      casesSortOrganization: sortData?.organization,
      casesSortCreatedBy: sortData?.createdBy,
      casesSortCreatedAt: sortData?.createdAt,
      casesSortAssignee: sortData?.assignee,
      casesSortCaseType: sortData?.caseType,
      casesSortProject: sortData?.project,
      casesSortResolveTime: sortData?.resolveTime,
      casesSortFirstResponseTime: sortData?.firstResponseTime,
      casesSortPriority: sortData?.priority,
      casesSortStatus: sortData?.status,
      casesCaseType: caseType,
      casesPriority: priority,
      casesStakeholder: stakeholder,
      casesAssignee: assignee,
      casesOrganization: organization,
      casesProject: project,
      casesProjectSponser: projectSponser,
      casesEscalationManager: escalationManager,
      casesStatus: status,
      casesExcludeStatus: excludeStatus,
      casesHasAttachments: hasAttachments,
      casesIsEscalated: isEscalated,
      casesIsFirstResponseTimeViolated: isFirstResponseTimeViolated,
      casesIsSynced: isSynced,
      casesIsResolvedTimeViolated: isResolveTimeViolated,
      casesDate: date,
      casesSelectedSortKey: selectedSort?.key,
      casesSelectedSortValue: selectedSort?.value,
      casesModule: module,
      casesIsApproved: isApproved,
    };
    localStorage.setItem('casesPagePg', JSON.stringify(casesPagePg));
    // document.addEventListener('mousedown', handleClickOutside);
    let autoRefreshTime;
    if (autoRefresh !== 0) {
      autoRefreshTime = setInterval(() => {
        getAllData();
      }, autoRefresh * 1000);
    }
    return () => {
      // document.removeEventListener('mousedown', handleClickOutside);
      clearTimeout(autoRefreshTime);
    };
  }, [
    isSubmit,
    autoRefresh,
    page,
    pageSize,
    sortData?.id,
    sortData?.caseName,
    sortData?.organization,
    sortData?.createdBy,
    sortData?.createdAt,
    sortData?.assignee,
    sortData?.caseType,
    sortData?.project,
    sortData?.resolveTime,
    sortData?.firstResponseTime,
    sortData?.priority,
    sortData?.status,
    selectedSort?.key,
    selectedSort?.value,
    filtersApplied,
  ]);

  useEffect(() => {
    const functionToUpdateFilters = (key: string, value: any) => ({
      name: key,
      data: value,
    });
    const initialVal = JSON.parse(localStorage.getItem('casesPagePg'));

    const initialFiltersData = {
      search: functionToUpdateFilters(
        'Search',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesSearch
      ),
      caseType: functionToUpdateFilters(
        'Case Type',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesCaseType
      ),
      status: functionToUpdateFilters(
        'Status',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesStatus
      ),
      excludeStatus: functionToUpdateFilters(
        'Exclude Status',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesExcludeStatus
      ),
      priority: functionToUpdateFilters(
        'Priority',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesPriority
      ),
      project: functionToUpdateFilters(
        'Project',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesProject
      ),
      organization: functionToUpdateFilters(
        'Organization',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesOrganization
      ),
      escalationManager: functionToUpdateFilters(
        'Escalation Manager',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesEscalationManager
      ),
      stakeholder: functionToUpdateFilters(
        'Stakeholder',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesStakeholder
      ),
      projectSponser: functionToUpdateFilters(
        'Project Sponsor',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesProjectSponser
      ),
      assignee: functionToUpdateFilters(
        'Assignee',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesAssignee
      ),
      date: functionToUpdateFilters(
        'Date',
        initialVal?.casesDate?.from && initialVal?.casesDate?.to
          ? [
              `${moment(initialVal?.casesDate?.from).format(
                'YYYY-MM-DD'
              )} - ${moment(initialVal?.casesDate?.to).format('YYYY-MM-DD')}`,
            ]
          : []
      ),
      // escalatedCases,
      hasAttachments: functionToUpdateFilters(
        'Attachments',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesHasAttachments
          ? ['true']
          : []
      ),
      isFirstResponseTimeViolated: functionToUpdateFilters(
        'First Time Violated',
        JSON.parse(localStorage.getItem('casesPagePg'))
          ?.casesIsFirstResponseTimeViolated
          ? ['true']
          : []
      ),
      escalatedCases: functionToUpdateFilters(
        'Escalated Cases',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesIsEscalated
          ? ['true']
          : []
      ),
      isResolveTimeViolated: functionToUpdateFilters(
        'Resolve Time Violated',
        JSON.parse(localStorage.getItem('casesPagePg'))
          ?.casesIsResolvedTimeViolated
          ? ['true']
          : []
      ),
      module: functionToUpdateFilters(
        'Module',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesModule
      ),
      isApproved: functionToUpdateFilters(
        'isApproved',
        JSON.parse(localStorage.getItem('casesPagePg'))?.casesIsApproved &&
          JSON.parse(localStorage.getItem('casesPagePg'))?.casesIsApproved !==
            'null'
          ? [JSON.parse(localStorage.getItem('casesPagePg'))?.casesIsApproved]
          : []
      ),
    };
    setFiltersApplied(initialFiltersData);
  }, []);

  useEffect(() => {
    console.log('Filters Applied:', filtersApplied);
  }, [filtersApplied]);

  useEffect(() => {
    if (location.hash === '#create') {
      addCases(true, null);
    }
  }, [location]);

  const handleExport = async () => {
    try {
      // Get visible columns, exclude 'attachment' and handle Time (Logged/Est) specially
      const visibleColumns = columns
        .filter((col) => col.isVisible && col.id !== 'attachment') // Exclude attachment column
        .reduce((acc, col) => {
          if (col.id === 'totalLoggedTime') {
            // Split into two columns
            return {
              ...acc,
              totalLoggedTime: 'Logged Time',
              timeEstimate: 'Estimated Time',
            };
          }
          return {
            ...acc,
            [col.id]: col.label,
          };
        }, {});

      const payload = {
        advanceFilter: {
          page,
          pageSize,
          search,
          caseType: caseType?.map((itm) => itm.id).toString(),
          priority: priority?.map((itm) => itm.id).toString(),
          stakeholder: stakeholder?.map((itm) => itm.id).toString(),
          assignee: assignee?.map((itm) => itm.id).toString(),
          projectSponser: projectSponser?.map((itm) => itm.id).toString(),
          escalationManager: escalationManager?.map((itm) => itm.id).toString(),
          status: status?.map((itm) => itm.id).toString(),
          statusNotInclude: excludeStatus?.map((itm) => itm.id).toString(),
          projectId: project?.map((itm) => itm.id).toString(),
          organizationId: organization?.map((itm) => itm.id).toString(),
          hasAttachments,
          isEscalated,
          isFirstResponseTimeViolated,
          isSynced,
          isResolveTimeViolated,
          from: date?.from,
          to: date?.to,
          column: selectedSort?.key
            ? fieldToColumnMap[selectedSort?.key]
            : undefined,
          sort: selectedSort?.value === 'asc' ? '1' : '-1',
          module: module || '',
          ...(isApproved &&
            isApproved?.value !== 'null' && { isApproved: isApproved?.value }),
        },
        fieldList: visibleColumns,
      };

      const response = await casesApi.exportCases(payload);

      // Create blob and download file
      const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `cases-export-${moment().format('YYYY-MM-DD')}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error('Failed to export cases');
    }
  };

  const handleColumnReset = () => {
    // Define default visible columns in the desired order
    const defaultVisibleColumns = [
      'attachment',
      'caseKey',
      'summary',
      'priority',
      'status',
      'project',
      'createdBy',
      'assignee',
      'totalLoggedTime',
      'createdAt',
    ];

    // Reset columns to default visibility and order
    const resetColumns = columns.map((col) => ({
      ...col,
      isVisible: defaultVisibleColumns.includes(col.id),
    }));

    // Sort columns according to defaultVisibleColumns order
    const orderedColumns = [];

    // First add columns in the default order
    defaultVisibleColumns.forEach((id) => {
      const column = resetColumns.find((col) => col.id === id);
      if (column) orderedColumns.push(column);
    });

    // Then add any remaining columns
    resetColumns.forEach((col) => {
      if (!defaultVisibleColumns.includes(col.id)) {
        orderedColumns.push(col);
      }
    });

    setColumns(orderedColumns);

    // Store the reset configuration in localStorage
    const visibilitySettings = orderedColumns.reduce(
      (acc, col) => ({
        ...acc,
        [col.id]: col.isVisible,
      }),
      {}
    );
    localStorage.setItem(
      'casesTableColumns',
      JSON.stringify(visibilitySettings)
    );

    // Store the reset order
    const orderIds = orderedColumns.map((col) => col.id);
    localStorage.setItem('casesTableColumnOrder', JSON.stringify(orderIds));
  };

  const [openBulkCreate, setOpenBulkCreate] = useState(false);

  const handleBulkCreateOpen = () => {
    setOpenBulkCreate(true);
  };

  const handleBulkCreateClose: DialogProps['onClose'] = (event, reason) => {
    if (reason && reason === 'backdropClick') return;
    setOpenBulkCreate(false);
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 4,
        }}
        className={classes.ticketMain}>
        <Container
          maxWidth={settings.compact ? 'xl' : false}
          className={
            hiddenColumns?.customCss === 'customCss' ? 'customCss' : ''
          }>
          <Grid container justifyContent="space-between" spacing={3}>
            {hiddenColumns?.heading === false ? (
              ''
            ) : (
              <Grid item>
                <Typography color="textPrimary" variant="h3">
                  Cases
                </Typography>
              </Grid>
            )}
          </Grid>
          <Box sx={{ mt: 1 }}>
            <Grid container>
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}>
                {user?.permissions?.includes('case-filter-search-read') && (
                  <SearchBar
                    onSearch={handleSearch}
                    value={search}
                    anyState={autoRefresh !== 0}
                  />
                )}
                {user?.permissions?.includes(
                  'case-filter-advanced-search-read'
                ) && (
                  <Button
                    variant="contained"
                    color="secondary"
                    sx={{ height: 30, marginLeft: 1 }}
                    onClick={toggleAdvancedSearch}
                    disabled={autoRefresh !== 0}>
                    Advanced Search
                  </Button>
                )}
                {user?.permissions?.includes(
                  'case-filter-autorefresh-read'
                ) && (
                  <Select
                    value={autoRefresh}
                    onChange={handleAutoRefresh}
                    sx={{ height: 30, marginLeft: 1, fontWeight: 'normal' }}>
                    <MenuItem selected value={0}>
                      Refresh
                    </MenuItem>
                    <MenuItem value={30}>30 sec</MenuItem>
                    <MenuItem value={60}>1 min</MenuItem>
                    <MenuItem value={300}>5 mins</MenuItem>
                    <MenuItem value={900}>15 mins</MenuItem>
                  </Select>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  flexWrap: 'wrap',
                  gap: 1,
                }}>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<FileDownloadIcon />}
                  onClick={handleExport}
                  sx={{
                    height: 30,
                    whiteSpace: 'nowrap',
                    minWidth: 'auto',
                  }}>
                  Export
                </Button>
                <Button
                  className="bulkChange"
                  variant="contained"
                  color="secondary"
                  sx={{
                    height: 30,
                    whiteSpace: 'nowrap',
                    minWidth: 'auto',
                  }}
                  onClick={openModal}>
                  Bulk Change
                </Button>
                {user?.permissions?.includes('case-create') && (
                  <Button
                    variant="contained"
                    color="secondary"
                    endIcon={<AddCircleIcon />}
                    onClick={handleBulkCreateOpen}
                    sx={{
                      height: 30,
                      whiteSpace: 'nowrap',
                      minWidth: 'auto',
                    }}>
                    Bulk Create
                  </Button>
                )}
                {user?.permissions?.includes('case-create') && (
                  <Button
                    variant="contained"
                    color="secondary"
                    endIcon={<AddCircleIcon />}
                    // className={classes.btn}
                    sx={{ height: 30 }}
                    onClick={(e) => addCases(true, e)}>
                    Create case
                  </Button>
                )}
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<RestartAltIcon />}
                  className={classes.btn}
                  onClick={() => {
                    localStorage.removeItem('casesPagePg');
                    handlePageSize(25);
                    handlePage(0);
                    setSearch('');
                    setSortData({
                      id: 'asc',
                      caseName: 'asc',
                      organization: 'asc',
                      createdBy: 'asc',
                      createdAt: 'asc',
                      assignee: 'asc',
                      caseType: 'asc',
                      project: 'asc',
                      resolveTime: 'asc',
                      firstResponseTime: 'asc',
                      priority: 'asc',
                      status: 'asc',
                      totalLoggedTime: 'asc',
                      isApproved: 'asc',
                      dueDate: 'asc',
                      collaborators: 'asc',
                      reOpened: 'asc',
                      approvedDate: 'asc',
                    });
                    setCaseType([]);
                    setProject([]);
                    setPriority([]);
                    setOrganization([]);
                    setStakeholder([]);
                    setAssignee([]);
                    setProjectSponser([]);
                    setEscalationManager([]);
                    setStatus([]);
                    setExcludeStatus([]);
                    setHasAttachments(false);
                    setIsEscalated(false);
                    setIsFirstResponseTimeViolated(false);
                    setIsSynced(false);
                    setIsResolveTimeViolated(false);
                    setDate({ to: null, from: null });
                    setSelectedSort({ key: '', value: '' });
                    setModule(null);
                    setIsApproved(null);
                    setFiltersApplied({
                      search: null,
                      caseType: null,
                      status: null,
                      excludeStatus: null,
                      priority: null,
                      project: null,
                      organization: null,
                      escalationManager: null,
                      stakeholder: null,
                      projectSponser: null,
                      assignee: null,
                      date: null,
                      thirdPartySync: null,
                      escalatedCases: null,
                      hasAttachments: null,
                      isFirstResponseTimeViolated: null,
                      isResolveTimeViolated: null,
                      isApproved: null,
                      module: null,
                    });
                  }}
                />
                <ColumnConfig
                  columns={columns}
                  onColumnToggle={handleColumnToggle}
                  onColumnReorder={handleColumnReorder}
                  onReset={handleColumnReset}
                />
                {user?.permissions?.includes('case-delete') && (
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<DeleteIcon />}
                    className={classes.btn}
                    disabled={!bulkIds.length}
                    onClick={() => deleteCaseById(bulkIds)}
                    style={{ display: 'none' }}
                  />
                )}
              </Grid>
            </Grid>

            {Object.values(filtersApplied).some((val) => val !== null) && (
              <Box marginTop="5px" marginLeft="-5px">
                {/* Filters: */}
                {Object.keys(filtersApplied).map((keyName) =>
                  filtersApplied[keyName] !== null ? (
                    <Filter
                      filtersApplied={{ ...filtersApplied }}
                      key={keyName}
                      id={keyName}
                      setFiltersApplied={setFiltersApplied}
                      updateAutocompleteState={updateAutocompleteState}
                      setIsSubmit={setIsSubmit}
                    />
                  ) : (
                    ''
                  )
                )}
              </Box>
            )}
            <CaseFilter
              // _headingMain="Advanced Search"
              _isOpen={showAdvancedSearch}
              _setShowAdvancedSearch={setShowAdvancedSearch}
              _handleSubmit={() => null}
              _search={search}
              _setSearch={setSearch}
              _caseType={caseType}
              _setCaseType={setCaseType}
              _priority={priority}
              _setPriority={setPriority}
              _stakeholder={stakeholder}
              _setStakeholder={setStakeholder}
              _assignee={assignee}
              _setAssignee={setAssignee}
              _projectSponser={projectSponser}
              _setProjectSponser={setProjectSponser}
              _escalationManager={escalationManager}
              _setEscalationManager={setEscalationManager}
              _status={status}
              _setStatus={setStatus}
              _excludeStatus={excludeStatus}
              _setExcludeStatus={setExcludeStatus}
              _hasAttachments={hasAttachments}
              _setHasAttachments={setHasAttachments}
              _isEscalated={isEscalated}
              _setIsEscalated={setIsEscalated}
              _isFirstResponseTimeViolated={isFirstResponseTimeViolated}
              _setIsFirstResponseTimeViolated={setIsFirstResponseTimeViolated}
              _isSynced={isSynced}
              _setIsSynced={setIsSynced}
              _isResolveTimeViolated={isResolveTimeViolated}
              _setIsResolveTimeViolated={setIsResolveTimeViolated}
              _date={date}
              _setDate={setDate}
              _project={project}
              _setProject={setProject}
              _setPage={setPage}
              _organization={organization}
              _setOrganization={setOrganization}
              _setFiltersApplied={setFiltersApplied}
              _filtersApplied={filtersApplied}
              isSubmit={isSubmit}
              setIsSubmit={setIsSubmit}
              _module={module}
              _setModule={setModule}
              _isApproved={isApproved}
              _setIsApproved={setIsApproved}
            />
            {user?.permissions?.includes('case-get-all') && (
              <CasesTable
                data={allData}
                sortData={sortData}
                toggleSortData={toggleSortData}
                selectedSort={selectedSort}
                setSelectedSort={setSelectedSort}
                redirectUrl="/erp/cases"
                editRouteUrl="/erp/cases"
                page={page}
                limit={pageSize}
                handleLimit={handlePageSize}
                handlePage={handlePage}
                count={totalCount}
                bulkIds={bulkIds}
                handleAddBulkIds={handleAddBulkIds}
                handleRemoveBulkIds={handleRemoveBulkIds}
                permissions={permissions}
                newTicketIds={newTicketIds}
                columns={columns}
                setColumns={setColumns}
              />
            )}
          </Box>
        </Container>
      </Box>

      {/* Modal component */}
      <AllProjects isOpen={isModalOpen} onClose={closeModal} />

      {drawer && (
        <CreateCase
          isOpen={drawer}
          addCases={addCases}
          closeDrawer={handleCloseDrawer}
          getAllData={getAllData}
          nested={false}
        />
      )}

      <BulkCreateDialog open={openBulkCreate} onClose={handleBulkCreateClose} />
    </>
  );
}

export default ViewCases;
